import TokenStorageService from './token-storage.service';
import authInterceptorModule from './interceptor/interceptor.module';
import LoginService from './login.service';
import {AuthGuard} from './auth-guard';

export default angular.module('imomo.auth', [authInterceptorModule])
    .service('loginService', LoginService)
    .service('tokenStorageService', TokenStorageService)
    .run(AuthGuard.configureEnterGuard)
    .name;



/** WEBPACK FOOTER **
 ** ./app/auth/auth.module.ts
 **/